import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "companyNoLabelAsterix",
    "vatNoLabelAsterix",
    "organizationLabelAsterix",
    "organizationErrorBlock",
    "vatNoErrorBlock",
    "companyNoErrorBlock"
  ];

  connect() {}

  onChangeBusinessType() {
    const locale = document.documentElement.lang
    if (locale === "hu") {
      this.companyNoLabelAsterixTarget.classList.toggle("is-hidden");
      this.vatNoLabelAsterixTarget.classList.toggle("is-hidden");
      if (this.hasVatNoErrorBlockTarget) {
        this.toggleError(this.vatNoErrorBlockTarget)
      }
      if (this.hasCompanyNoErrorBlockTarget) {
        this.toggleError(this.companyNoErrorBlockTarget)
      }
    }
    this.organizationLabelAsterixTarget.classList.toggle("is-hidden");
    if (this.hasOrganizationErrorBlockTarget) {
      this.toggleError(this.organizationErrorBlockTarget)
    }
  }

  toggleError(errorElement) {
    errorElement.textContent = '';
    errorElement.classList.add = 'is-hidden';
  }
}
